import React from 'react';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import {
  useDrilldownParams,
  EDrilldownMode,
} from '@op/hooks/useDrilldownParams';

export default function BubbleGoPage({
  children,
  title,
  logId,
  pagePath,
  filter,
}: {
  children: any;
  title: string;
  logId?: string;
  pagePath: string;
  filter: any;
}) {
  const { goPage } = useDrilldownParams();
  function goToOtherPage() {
    goPage({
      path: pagePath,
      filter,
      // 特殊页面（Community/Feeds/Accounts 等），走本地缓存
      mode: EDrilldownMode.Local,
    });
  }

  return (
    <Bubble
      content={
        <div
          className="goto-page"
          onClick={(e) => {
            e.stopPropagation();
            logId && buriedBtnPoint(logId, title);
            return goToOtherPage();
          }}
        >
          <SvgIcon type="back-link"></SvgIcon>
          <span>{title}</span>
        </div>
      }
      overlayClassName="dbo-bubble-gourl"
    >
      {children}
    </Bubble>
  );
}
